import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

const icon = (active, recommended) => L.divIcon({
  className: '',
  html: `<div style="width:28px;height:28px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);background:${active ? '#f97316' : recommended ? '#f59e0b' : '#1e3a5f'};border:2px solid ${recommended ? '#fde68a' : '#fff'};box-shadow:0 2px 6px rgba(0,0,0,.35)${recommended ? ',0 0 0 3px rgba(245,158,11,.35)' : ''}"></div>`,
  iconSize: [28, 28], iconAnchor: [14, 28], popupAnchor: [0, -26],
});
const homeIcon = L.divIcon({ className: '', html: '<div style="width:14px;height:14px;border-radius:50%;background:#16a34a;border:3px solid #fff;box-shadow:0 0 0 2px #16a34a"></div>', iconSize: [14, 14], iconAnchor: [7, 7] });

const FitBounds = ({ points }) => {
  const map = useMap();
  useEffect(() => { if (points.length) map.fitBounds(L.latLngBounds(points), { padding: [30, 30], maxZoom: 13 }); }, [map, points]);
  return null;
};

// Checkout map of partner fitting centres (OpenStreetMap tiles, no API key)
const FittingCentresMap = ({ centres, origin, value, onSelect }) => {
  const located = centres.filter((c) => c.lat != null && c.lon != null);
  if (!located.length) return null;
  const points = located.map((c) => [c.lat, c.lon]);
  if (origin) points.push([origin.lat, origin.lon]);
  return (
    <div className="h-64 rounded-lg overflow-hidden border border-gray-200 mb-3" data-testid="fitting-map">
      <MapContainer center={points[0]} zoom={11} scrollWheelZoom={false} style={{ height: '100%', width: '100%' }}>
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <FitBounds points={points} />
        {origin && <Marker position={[origin.lat, origin.lon]} icon={homeIcon}><Popup>Votre adresse de livraison</Popup></Marker>}
        {located.map((c) => (
          <Marker key={c.id} position={[c.lat, c.lon]} icon={icon(value === c.id, c.recommended)} eventHandlers={{ click: () => onSelect(c.id) }}>
            <Popup>{c.recommended && <span style={{ color: '#b45309', fontWeight: 700, fontSize: 11 }}>★ Recommandé — le mieux noté<br /></span>}<strong>{c.name}</strong><br />{c.address}, {c.postcode} {c.city}<br />{Number(c.price_per_tyre).toFixed(2).replace('.', ',')} € / pneu{c.distance_km != null ? ` · à ${String(c.distance_km).replace('.', ',')} km` : ''}<br /><button type="button" onClick={() => onSelect(c.id)} style={{ marginTop: 6, background: '#f97316', color: '#fff', border: 0, borderRadius: 4, padding: '4px 10px', fontWeight: 600, cursor: 'pointer' }}>Choisir ce centre</button></Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};

export default FittingCentresMap;
